import { ApplicantSubmissionDocumentSources } from 'src/ts/enums/applicant';

const labelByApplicantSubmissionDocumentSource = (
  source_type: ApplicantSubmissionDocumentSources
): string => {
  switch (source_type) {
    case ApplicantSubmissionDocumentSources.BANK_LINKING:
      return 'Bank Linking';
    case ApplicantSubmissionDocumentSources.CONNECTED_PAYROLL:
      return 'Connected Payroll';
    case ApplicantSubmissionDocumentSources.TAX_RETURN_LINKING:
      return 'Connected Tax Data';
    default:
      return 'Connected Payroll';
  }
};

export default labelByApplicantSubmissionDocumentSource;
